import { createTheme } from "@mui/material/styles"
import TextFieldsStyles from "@/theme/inputs/TextFields";
import PopoverStyle from "@/theme/popover";
import DialogStyles from "@/theme/dialog";
import { ListItemStyles } from "@/theme/list/ListItemStyles";
import { ListStyles } from "@/theme/list/ListStyles";

const theme = createTheme({
  components:{
    MuiTextField: TextFieldsStyles(),
    MuiPopover: PopoverStyle(),
    MuiDialog: DialogStyles(),
    MuiListItem: ListItemStyles(),
    MuiList: ListStyles(),
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 0,
          marginRight: '8px',
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'var(--Schemes-Secondary-Container)',
        }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "14px",
          lineHeight: "20px",
          letterSpacing: "0.1px"
        },
        text: {
          color: "var(--Schemes-Primary)"
        },
        contained: {
          color: "var(--Schemes-On-Primary)",
          background: "var(--Schemes-Primary)",
          borderRadius: "100px"
        },
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          '&::before, &::after': {
            borderBottom: '0px solid var(--Schemes-Primary)',
          },
          '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: '0px solid var(--Schemes-Primary)',
          },
          '&.Mui-focused:after': {
            borderBottom: '3px solid var(--Schemes-Primary)',
          },
        }
      }
    }
  }
})
export default theme